import Helpers from "../../../services/helpers";

const TIMESPAN_SETTINGS = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
};

const TREND_SETTINGS = {
  LINE_ONLY: "line_only",
  TREND_ONLY: "trend_only",
  LINE_AND_TREND: "line_and_trend",
};

const YAXIS_SETTINGS = {
  LOW_SALE: "low_sale",
  ZERO: "zero",
};

const CHART_SETTINGS = {
  TIMESPAN: "timespan",
  TREND: "trendLine",
  YAXIS: "yAxis",
};

const DATA_KEY_BY_CHART = {
  valuePerDay: "avg",
  percentageGrowthChart: "percentage",
  totalSales: "totalsales",
  numberOfSales: "count",
};

const getPercentage = (percentage) => {
  if (!percentage || !Number(percentage)) return "";
  return `(${percentage.toFixed(1)}%)`;
};

const OPTIONS_BY_CHART = {
  valuePerDay: {
    hasTrendLineControl: true,
    hasYAxisControl: true,
    yTickFormatter: (value) => Helpers.formatMoney(value, 0),
    tooltipEntryValueFormatter: (value, payload, dataKey) => {
      const cardId = dataKey.split("_")[0];
      return `${Helpers.formatMoney(value)} ${getPercentage(payload[`${cardId}_percentage`])}`;
    },
  },
  numberOfSales: {
    hasTrendLineControl: false,
    hasYAxisControl: false,
    yTickFormatter: (value) => value,
    tooltipEntryValueFormatter: (value) => value,
  },
  totalSales: {
    hasTrendLineControl: false,
    hasYAxisControl: false,
    yTickFormatter: (value) => Helpers.formatMoney(value, 0),
    tooltipEntryValueFormatter: (value) => Helpers.formatMoney(value),
  },
  percentageGrowthChart: {
    hasTrendLineControl: false,
    hasYAxisControl: false,
    yTickFormatter: (value) => `${value}%`,
    tooltipEntryValueFormatter: (value, payload, dataKey) => {
      const cardId = +dataKey.split("_")[0];
      return `${Helpers.formatMoney(payload[`${cardId}_avg`])} (${value.toFixed(1)}%)`;
    },
  },
};

export { TIMESPAN_SETTINGS, CHART_SETTINGS, YAXIS_SETTINGS, TREND_SETTINGS, DATA_KEY_BY_CHART, OPTIONS_BY_CHART };
